import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TenantsService } from '../services/tenants.service';
import { Tenants } from '../enums/page-type.enum';
import { SelectionService } from '../services/selection.service';
import { TextHelper } from '../helpers/text.helper';

@Injectable({ providedIn: 'root' })
export class TenantGuard {
  constructor(private tenantsService: TenantsService, private selectionService: SelectionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let tenantUrlName = route.params.tenantUrlName as string;
    this.tenantsService.showWorkflows = tenantUrlName === Tenants.AllWorkflows;
    if (tenantUrlName === Tenants.AllTenants || tenantUrlName === Tenants.AllWorkflows) {
      
      if (this.tenantsService.tenants.length === 1) {
        tenantUrlName = this.tenantsService.tenants[0] ?
          TextHelper.getUrlNameFromLabel(this.tenantsService.tenants[0].label) :
          null;
      } else {
        tenantUrlName = null;  // Multi-tenant: use null for "all tenants"
      }
    }
    this.selectionService.clear();
    this.tenantsService.selectTenantByUrlName(tenantUrlName); // sets _selectedTenant
    return true;
  }
}
